import React from 'react';
import { Certificates } from 'src/components/Certificates/Certificates';
import { FooterAction } from 'src/components/Footer/FooterAction';

import classes from './FooterCta.scss';

type FooterCtaProps = Record<string, unknown>;

export const FooterCta: React.FC<FooterCtaProps> = () => (
    <>
        <FooterAction className={classes.footerCtaAction} />
        <Certificates isFooter className={classes.ctaCertificates} />
    </>
);
